import { Box, Container } from '@chakra-ui/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { ImageProps } from 'types/umbraco';

export default function ImageBlock({ blockMedia }: ImageProps): JSX.Element {
  const router = useRouter();
  const home = router.route === '/';
  return (
    <Container maxW="4xl" pos="relative" h="400">
      <Box>
        <Image
          src={blockMedia[0].url}
          fill
          className="heroObjectFit"
          priority={true}
          loading="eager"
          alt={blockMedia[0].altText ?? 'image'}
        />
        <style jsx global>{`
          .heroObjectFit {
            object-fit: cover;
          }
        `}</style>
      </Box>
    </Container>
  );
}
